import styled from '@emotion/styled';
import { mq } from 'style';

export const DetailsContainer = styled.div`
  padding-bottom: 0;
  ${mq.mobile()} {
    padding-bottom: 24px;
    padding-top: 24px;
  }
`;